import { useContext, useMemo } from 'react';

import { FunnelContext } from 'components/signUpFunnel/Contexts';
import { getFunnelProgressSteps, stepLabelForRoute } from 'helpers/funnelProgress';
import useFunnelNavigation from 'hooks/useFunnelNavigation';

const FunnelStatus = () => {
  const { funnel } = useContext(FunnelContext);
  const { currentStep } = useFunnelNavigation();

  const statusText = useMemo(() => {
    const steps = getFunnelProgressSteps(funnel);
    const currentStepName = stepLabelForRoute(currentStep?.route);
    const currentStepIndex = steps.findIndex(step => step.name === currentStepName);

    return `Step ${currentStepIndex + 1} of ${steps.length}: ${currentStepName}`;
  }, [currentStep, funnel]);

  return (
    <div role="status" aria-live="polite" aria-atomic="true" className="sr-only">
      {statusText}
    </div>
  );
};

export default FunnelStatus;
